import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../gettingstarted.css';
import CourseNavigation from '../../../../course-navigation/CourseNavigation';
import IntroToIDEsLesson from '../../lessons/01_IntroToIDEs_Lesson.jsx';


export default function IntroToIDEsPage() {

    const memberData = JSON.parse(localStorage.getItem("memberData"));

    return (
        <div className="gs-container">
            <div className="content">
                <div>
                    <h1>Getting Started</h1>
                </div>
                <div className="gs-lessons">
                    <div className="menu">
                        <h2>Course Track</h2>
                        <ul className="menu-track">
                            <CourseNavigation memberData={memberData}/>
                        </ul>
                    </div>

                    <div className="lesson-container">
                        <IntroToIDEsLesson memberData={memberData}/>
                    </div>
                </div>
            </div>
        </div>
    )
}
